import axios from 'axios'

export default function PurchaseorderrequestImportService(formData, requestId) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/purchase_order_request/" + requestId + "/import",
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  })
}
